// main.js or main.ts
import { createApp } from 'vue';
import App from './App.vue';
import './index.css';
import config from '../formkit.config.js';
import { plugin, defaultConfig } from '@formkit/vue';

// Create the Vue app
const app = createApp(App);


// Use router and formkit plugin
app.use(plugin, defaultConfig(config));

// Mount the app to the DOM
app.mount('#app');
